export const DELIVERY_NOTE_ROUTE_ROOT = '/delivery-note';

export const DELIVERY_NOTE_ROUTES = {
  DELIVERY_NOTE: DELIVERY_NOTE_ROUTE_ROOT,
  LIST: `${DELIVERY_NOTE_ROUTE_ROOT}/list`,
  DETAIL: `${DELIVERY_NOTE_ROUTE_ROOT}/detail`,
  WILDCARD: `${DELIVERY_NOTE_ROUTE_ROOT}/*`,
} as const;
